import { render, staticRenderFns } from "./ResultTypePatientsModal.vue?vue&type=template&id=76e283a8"
import script from "./ResultTypePatientsModal.vue?vue&type=script&lang=js"
export * from "./ResultTypePatientsModal.vue?vue&type=script&lang=js"
import style0 from "./ResultTypePatientsModal.vue?vue&type=style&index=0&id=76e283a8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports